import { render } from "./Botones_flotantes.vue?vue&type=template&id=01fb5de0&scoped=true"
import script from "./Botones_flotantes.vue?vue&type=script&lang=js"
export * from "./Botones_flotantes.vue?vue&type=script&lang=js"

import "./Botones_flotantes.vue?vue&type=style&index=0&id=01fb5de0&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fb5de0"]])

export default __exports__